import { trackLink } from '@99designs/common/utils/platform';

document.addEventListener('DOMContentLoaded', () => {
    const launchCta = document.querySelectorAll('[data-launch-category-cta]');

    Array.from(launchCta).forEach(element => {
        trackLink(element, 'Clicked CTA on Launch page', {
            cta_location: element.getAttribute('data-launch-category-cta-location'),
            cta_category: element.getAttribute('data-launch-category-cta-category'),
        });
    });
});
